<template>
    <svg class="mark" viewBox="0 0 66.0979 61.6592" fill="none" aria-hidden="true" focusable="false">
        <defs>
            <clipPath :id="clipId"><circle cx="40.6322" cy="25.5424" r="25.4643" /></clipPath>
        </defs>
        <circle class="back" cx="40.6322" cy="25.5424" r="25.4643" />
        <circle class="front" cx="25.5619" cy="36.1928" r="25.4643" />
        <g :clip-path="`url(#${clipId})`">
            <circle class="overlap" cx="25.5619" cy="36.1928" r="25.4643" />
        </g>
    </svg>
</template>

<script setup lang="ts">
import { useId } from "vue";

const clipId = useId();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .mark {
        @apply block h-7 w-7.5 shrink-0;
    }

    .back {
        fill: var(--color-setup-tile-profile-back);
    }

    .front {
        fill: var(--color-setup-tile-profile-front);
    }

    .overlap {
        fill: var(--color-setup-tile-profile-over);
    }
}
</style>
